
var id = "nkc";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"nkc\">\n<style type=\"text/css\">\n\t#nkc .st0{fill:'';}\n</style>\n<path class=\"st0\" d=\"M64,124c-2.8,0-5.6-1.2-7.6-3.6l-54-61.2c-2.8-3.2-3.2-8-1.2-11.6L22.8,9.2C24.8,6,28,4,31.6,4H96\n\tc3.6,0,6.8,2,8.8,5.2l22,38.8c2,3.6,1.6,8.4-1.2,11.6L72,120.4C70,122.8,67.2,124,64,124 M64,114C64,114,64.4,114,64,114l54-61.2\n\tL96,14H31.6L10,52.4L64,114z M94,47.6H34V40c0-2.8,2.4-5.2,5.2-4.8h50c2.8,0,5.2,2.4,5.2,4.8C94.4,40,94,47.6,94,47.6z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
